import React, { Component } from 'react';
import { Form, FormGroup, ControlLabel, Row, Col, Button, Radio } from 'react-bootstrap';
import Api from './../../../Global/Modules/Api'

const FETCH_URL = "api/members/requestchange"

class Aanvraag extends Component {

    constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this)
        this.state = {
            memberType: 1,
            visible: true
        }
    }

    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        this.setState({ [name]: value })
    }

    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault()

        // TODO: Post state to the API
        Api.PostApi(FETCH_URL, { memberType: this.state.memberType }, this.props.history)
            .then(data => {
                this.setState({ visible: false })
                alert("Uw aanvraag is ingediend. Het secretariaat zal beoordelen of uw aanvraag toegekend zal worden. U zal hier nader over ingelicht worden.")
            })
    }

    render() {
        return (
            <div>
                <Row style={{ display: this.state.visible ? 'block' : 'none' }}>
                    <Col sm={5}>
                        <Form onSubmit={this.handleSubmit}>
                            <FormGroup controlId="Account">
                                <Col componentClass={ControlLabel} sm={12}>
                                    Type aanvraag
                            </Col>
                            </FormGroup>
                            <FormGroup >
                                <Col componentClass={ControlLabel} sm={12}>
                                    <Radio name="memberType" value={1} defaultChecked={this.state.memberType === 1} onChange={this.handleChange}>
                                        Op voor RC
                                    </Radio>{' '}
                                    <Radio name="memberType" value={2} defaultChecked={this.state.memberType === 2} onChange={this.handleChange}>
                                        Op voor RO
                                    </Radio>{' '}
                                    <Radio name="memberType" value={3} defaultChecked={this.state.memberType === 3} onChange={this.handleChange}>
                                        Op voor RT a
                                    </Radio>
                                    <Radio name="memberType" value={4} defaultChecked={this.state.memberType === 4} onChange={this.handleChange}>
                                        Op voor RT b
                                    </Radio>
                                </Col>
                            </FormGroup>

                            <FormGroup>
                                <Col sm={12}>
                                    <Button type="submit">Aanvraag indienen</Button>
                                </Col>
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Aanvraag;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/AanvraagIndienen/Aanvraag.js